<app-settings-card heading="Bankverbindung" (save)="saveSettings()" [disabled]="disabled">
  <form>
    <app-bank-connection-form
      class="block mt-6"
      [bankConnectionFormGroup]="bankDetailForm"
    ></app-bank-connection-form>
  </form>
</app-settings-card>
